import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BsTwitterX } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

import styles from '../styles/Footer.module.css'; // Assuming you have a CSS module for styling

const Footer = () => {

    const navigate = useNavigate();

    return (
        <footer className={styles.footer}>
          
            <div className={styles.subscription}>
                <h4 style={{fontSize:'30px',margin:0,fontWeight:400}}>
                  Let's <span style={{color:'#FF6F30'}}>Connect</span> there
                </h4>
                <button className={styles.subscribeButton} onClick={()=>navigate('/contact-us')}>
                  Contact Us
                </button>
            </div>

            <div style={{display:'flex',justifyContent:'space-between',flexWrap:'wrap'}}>

                <div className={styles.logo}>

                    <div className={styles.logoContent}>

                      <div style={{width:'70px',height:'50px'}}>
                        <img src='../static/media/gwc_logo.6d48a5c56c4899d54e5a.png' style={{width:'100%',height:'100%'}} alt="GWC Logo" />
                      </div>
                      <div className={styles.brand} style={{fontSize:'25px'}}>
                        Greenworks Consulting
                      </div>

                    </div>

                    <p className={styles.description} style={{maxWidth:'400px',color:'#ccc',marginTop:'5px'}}>
                      Greenworks Consulting provides expert guidance and strategic solutions to help businesses meet their sustainability goals.
                    </p>

                    <div className={styles.socialIcons}>
                        <button className={styles.icon} onClick={() => window.open('https://x.com/home')}>
                          <BsTwitterX />
                        </button>
                        <button className={styles.icon} onClick={
                          ()=>window.open('https://www.linkedin.com/company/93344403/admin/dashboard/')
                        }>
                          <FaLinkedinIn />
                        </button>
                        <button className={styles.icon} onClick={
                          ()=>window.open('https://www.facebook.com/profile.php?id=61555218584816')
                        }>
                          <FaFacebookF />
                        </button>
                        <button className={styles.icon}>
                          <FaInstagram />
                        </button>
                    </div>

                </div>

                <div className={styles.content}>

                  <div className={styles.nav}>
                      <h4>Navigation</h4>
                      <ul>
                          <li onClick={()=>navigate('/')}>Home</li>
                          <li onClick={()=>navigate('/contact-us')}>Contact Us</li>
                          <li onClick={()=>navigate('/about')}>About Us</li>
                      </ul>
                  </div>

                  <div className={styles.nav}>
                      <h4>Themes & Projects</h4>
                      <ul>
                          <li onClick={()=>navigate('/projects')} >Projects</li>
                      </ul>
                  </div>

                  <div className={styles.nav}>
                      <h4>Work With Us</h4>
                      <ul>
                          <li onClick={()=>navigate('/career')}>
                              Job Opportunities
                          </li>
                      </ul>
                  </div>

                  <div className={styles.nav}>
                      <h4>News</h4>
                      <ul>
                          <li onClick={()=>navigate('/news')}>
                            Newsletters
                          </li>
                          <li>
                            Subscribe to Newsletter
                          </li>
                      </ul>
                  </div>

                </div>
            </div>
        </footer>
    );
};

export default Footer;
  